
import { UserActivityLogListItem } from "@gsx/common/src/types/http/admin/userActivityLog";
import { Container } from "inversify";
import { Component, Inject, Prop, Vue } from "vue-property-decorator";
import { AuthStore } from "../../../../common/src/stores/AuthStore";
import { Action } from "@gsx/common";
import { ConferenceListStore } from "../../stores/conference/ConferenceListStore";
import { OrganizationListStore } from "../../stores/organization/OrganizationListStore";
import analyticMap from "../industry-analytics/analyticMap";

@Component({
    components: {},
})
export default class NotificationEvent extends Vue {
    @Prop() userActivityLogListItem!: UserActivityLogListItem;
    @Inject("container") readonly container!: Container;
    authStore: AuthStore = this.container.get(AuthStore);
    Action = Action;
    analyticMap = analyticMap;
    conferenceListStore: ConferenceListStore = this.container.get(ConferenceListStore);
    organizationListStore: OrganizationListStore = this.container.get(OrganizationListStore);

    isOrganization() {
        return this.organizationListStore.items?.find(
            (item: { organizationid: string }) =>
                item.organizationid === this.userActivityLogListItem.value,
        );
    }

    isConference() {
        return this.conferenceListStore.items?.find(
            (item: { conferenceid: string }) =>
                item.conferenceid === this.userActivityLogListItem.value,
        );
    }

    isAnalytic() {
        return analyticMap[this.userActivityLogListItem.value!];
    }

    get convertToFavoriteName() {
        let name = "";
        let id = this.userActivityLogListItem.value!;

        const conference = this.conferenceListStore.items?.find(
            (item: { conferenceid: string }) => item.conferenceid === id,
        );
        const organization = this.organizationListStore.items?.find(
            (item: { organizationid: string }) => item.organizationid === id,
        );
        const analytic = analyticMap[id];

        if (conference) {
            name = conference.name;
        } else if (organization) {
            name = organization.organizationName;
        } else if (analytic) {
            name = analytic.component.replace(/([a-z])([A-Z])/g, "$1 $2"); // split camel case
        }

        return name;
    }

    get convertToUrl() {
        let url = "";
        let id = this.userActivityLogListItem.value!;

        const conference = this.conferenceListStore.items?.find(
            (item: { conferenceid: string }) => item.conferenceid === id,
        );
        const organization = this.organizationListStore.items?.find(
            (item: { organizationid: string }) => item.organizationid === id,
        );
        const analytic = analyticMap[id];

        if (conference) {
            url = "/dashboard/conferences";
        } else if (organization) {
            url = `/dashboard/organizations/${organization.organizationid}`;
        } else if (analytic) {
            url = "/dashboard/industry-analytics";
        }
        return url;
    }

    getOrgDetails() {
        const org = this.organizationListStore.items?.find(
            (org) => org.organizationid === this.userActivityLogListItem.value,
        );
        return {
            ...org,
        };
    }

    get analyticIconClass() {
        let id = this.userActivityLogListItem.value!;
        const analytic = analyticMap[id];
        return analytic.icon;
    }
}
